import React, { useEffect, useState } from 'react'
import { BsEye } from 'react-icons/bs'
import { MdEdit } from 'react-icons/md'
import Input from '../../components/input'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import useAxiosInstance from '../../hooks/useAxios'
import DropDownComponent from '../../components/DropdownComp'
import { useSelector } from 'react-redux'

const AllOrganisation = () => {
  const path = window.location.pathname
  const { accountType } = useSelector(e => e.globalAuth)
  const [selectedAccountType, setSelectedAccountType] = useState('all');
  const [activityStatus,setActivityStatus] = useState(null)
  const [AllOrganisation,setAllOrganisation] = useState([])
  const [searchOrg,setSearchOrg] = useState("");
  const [orgLoading,setOrgLoading] = useState(false)
  const axiosInstance = useAxiosInstance()  
  const getOrgImage = (img,name) =>{
    if(img === null || img == ''){
        return `https://wklogo.blob.core.windows.net/logos-small/${name[0]?.toUpperCase()}.png`
    }else{
        return img
    }
    }
  const getFilteredOrgs = (AllOrganisation,searchOrg) =>{
    if(!searchOrg){
        return AllOrganisation
    }
    return AllOrganisation?.filter(item=>item?.name?.toLowerCase().includes(searchOrg?.toLowerCase()) || item?.label?.toLowerCase().includes(searchOrg?.toLowerCase()))
  }

  useEffect(() => {
    setOrgLoading(true);
    axiosInstance
      .get(`admin/organisations/?org_type=${selectedAccountType}&activity_status=${activityStatus?activityStatus:''}`)
      .then((res) => {
        setAllOrganisation(res.data.organisations);
        setOrgLoading(false)
        })
      .catch((err) => {
        console.log(err);
        toast.error("Something went while getting orgs");
        setOrgLoading(false);
      });
  }, [selectedAccountType,activityStatus]);

  return (
    
     <div className='p-6 w-full'>
     <div className='text-2xl font-semibold'>Organisation{path == '/subscriptions-v2' && ' Products'} Management</div>
      {<div className='mt-4'>

        <div className='flex justify-between items-center w-full'> 
            <p className='text-sm font-semibold mb-4'>All Organisation</p>
            {path != '/subscriptions-v2' && 
            <Link to={'/addOrganisation'}><button 
                className='bg-black text-white text-sm rounded-xl px-2 py-1'>Add</button>
            </Link>}
        </div>

        {/* <input pla/> */}
        <div className='grid grid-cols-2 mt-1 gap-x-2'>
        <Input
        className='w-full'
        placeholder='Search orgs'
        value = {searchOrg}
        onChange = {e=>setSearchOrg(e.target.value)}
        />
        <select 
        onChange={(e)=>{
          setActivityStatus(e.target.value)
        }}
        className='border rounded-lg px-3 py-2 w-full focus:ring-0 focus:outline-gray-400 disabled:bg-gray-300'>
          <option value="">All</option>
          <option value="active">Active Orgs</option>
          <option value="inactive">InActive Orgs</option>
        </select>
        </div>
       {orgLoading && <p className='mt-4'>Loading orgs...</p>} 
      {!orgLoading &&
      <div className="overflow-x-auto h-[80vh]  overflow-y-auto mt-4 border rounded-lg">
        <table className="w-full">
          <thead className="border-b text-left">
            <th className="px-2 py-1 text-gray-700 text-sm">Action</th>
            <th className="px-2 py-1 text-gray-700 text-sm">Name</th>
            <th className="px-2 py-1 text-gray-700 text-sm">Image</th>
            <th className="px-2 py-1 text-gray-700 text-sm">Logo</th>
            <th className="px-2 py-1 text-gray-700 text-sm">ID</th>
            <th className="px-2 py-1 text-gray-700 text-sm">Label</th>
            <th className="px-2 py-1 text-gray-700 text-sm"><div className="flex whitespace-nowrap  gap-x-2"><button>Account Type </button> 
              <DropDownComponent
              options={['all',...accountType.map(at=>at?.label)]}
              sortBy={selectedAccountType}
              setSortBy={setSelectedAccountType}
              defaultValue="all"
              />
            </div></th>
			<th className="px-2 py-1 text-gray-700 text-sm">Report Count</th>
          </thead>
          <tbody className="divide-y">
            {(getFilteredOrgs(AllOrganisation,searchOrg) || []).map((org,index)=>{ return <tr key={index} className="bg-white odd:bg-gray-50">
                <td className="whitespace-nowrap px-2 py-2  text-gray-900">
                    {/* <button className='bg-yellow-200 text-white text-xl rounded-xl p-2'><MdEdit/></button> */}
                    <Link to={path=='/subscriptions-v2'? `/subscriptions-v2/edit-product/${org.name}` : `/editOrganisation/?org_id=${org.org_id}` }><button className='bg-black text-white text-xl rounded-xl p-2'><MdEdit/></button></Link>
                </td>
                <td className="whitespace-nowrap px-2 py-2  text-gray-900">
                    {org.name}
                </td>
                <td className="whitespace-nowrap px-2 py-2  text-gray-900">
                    <div 
                    style={{backgroundImage:`url('${getOrgImage(org?.org_img,org?.name)}')`}} 
                    className="h-[50px] w-full bg-center bg-no-repeat bg-contain"/>
                </td>
                <td className="whitespace-nowrap px-2 py-2  text-gray-900">
                    <div 
                    style={{backgroundImage:`url('${getOrgImage(org?.org_logo,org?.name)}')`}} 
                    className="h-[50px] w-full bg-center bg-no-repeat bg-contain"/>
                </td>
                <td className="whitespace-nowrap px-2 py-2  text-gray-900">
                    {org.org_id}
                </td>
                <td className="whitespace-nowrap px-2 py-2  text-gray-900">
                    {org.label}
                </td>
                <td className="whitespace-nowrap px-2 py-2  text-gray-900">
                    {org?.account_type?.name}
                </td>
                <td className="whitespace-nowrap px-2 py-2  text-gray-900">
                    {org?.report_count}
                </td>
                </tr>    
            })}
          </tbody>
        </table>
      </div>
      }
      </div>
	}	
    </div>
    
  )
}

export default AllOrganisation